module.exports = __webpack_public_path__ + "img/UTOTTE-8.63947e1d.jpg";